module.exports = __webpack_public_path__ + "static/media/alert.a6f095e0.mp3";